import { render, staticRenderFns } from "./ParticipantStatuses.vue?vue&type=template&id=677f1a7a&scoped=true&"
import script from "./ParticipantStatuses.vue?vue&type=script&lang=js&"
export * from "./ParticipantStatuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677f1a7a",
  null
  
)

export default component.exports